import {
  STATE_LIST_REQUESTED,
  STATE_LIST_LOADED,
  STATE_LIST_FAILED_TO_LOAD,
  GEOFILTER_LIST_REQUESTED,
  GEOFILTER_LIST_LOADED,
  GEOFILTER_LIST_FAILED_TO_LOAD,
  RESPONSE_CONSTRAINT_LIST_REQUESTED,
  RESPONSE_CONSTRAINT_LIST_LOADED,
  RESPONSE_CONSTRAINT_LIST_FAILED_TO_LOAD,
  NO_OP
} from './constants';

import callAPI from '../callAPI';

import {buildNestedList,formatGeofilterSelectOptions} from '../../utils';

export function loadListOfStates(){
  return callAPI({
    path:`/portal/v1/state/list`,
    begin:{
      type:STATE_LIST_REQUESTED,
      payload:() => ({})
    },
    success:{
      type:STATE_LIST_LOADED,
      payload:(res) => res.data
    },
    failure:{
      type:STATE_LIST_FAILED_TO_LOAD
    }    
  });
}

export function loadListOfStatesAndDMAs(){
  return callAPI({
    path:`/portal/v1/geofilter/list`,
    begin:{
      type:GEOFILTER_LIST_REQUESTED,
      payload:() => ({})
    },
    success:{
      type:GEOFILTER_LIST_LOADED,
      payload:(res) =>  res.data
    },
    failure:{
      type:GEOFILTER_LIST_FAILED_TO_LOAD
    }    
  });
}

export function loadListOfConstraintsForAgency(agencyId){
  return callAPI({
    path:`/portal/v1/agency/${agencyId}/constraint/list`,
    begin:{
      type:RESPONSE_CONSTRAINT_LIST_REQUESTED,
      payload:() => ({})
    },
    success:{
      type:RESPONSE_CONSTRAINT_LIST_LOADED,
      payload:(res) =>  (res.data || []).map((item) => ({agencyId:agencyId,...item}))
    },
    failure:{
      type:RESPONSE_CONSTRAINT_LIST_FAILED_TO_LOAD
    }    
  });  
}


// WEBPACK FOOTER //
// ./src/shared/redux/audience/actions.js